import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';


function* user(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/profile/' : config.credentials.url + '/profile/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions);

        if (response.id == undefined || response.id == null) {
            response["invalidToken"] = "Hubo un error";
        }

        switch (actions.queryType) {
            case "VIEW":
                yield put({ type: "USER_RESPONSE", value: response })
                break;
            case "LOGIN":
                yield put({ type: "USER_LOGIN_RESPONSE", value: response, access: actions.access })
                break;
            default:
                break;
        }
    } catch (error) {
        yield put({ type: "USER_RESPONSE", value: error })
    }
}

function* users(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/profile/?offset=0&limit=' + actions.limit : config.credentials.url + '/profile/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "USERS_RESPONSE_LIST", value: response })

    } catch (error) {
        yield put({ type: "USERS_RESPONSE_LIST", value: error })
    }
}

function* add(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/profile/', requestOptions);

        yield put({ type: "USER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "USER_RESPONSE", value: error })
    }
}

function* remove(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'delete', config.credentials.url + '/profile/' + actions.data + '/', requestOptions)

        yield put({ type: "USER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "USER_RESPONSE", value: error })
    }
}

function* edit(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/profile/' + actions.id + '/', requestOptions)

        yield put({ type: "USER_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "USER_RESPONSE", value: error })
    }
}

function* permissions(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = config.credentials.url + '/permission/?offset=0&limit=' + actions.limit;

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "PERMISSIONS_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PERMISSIONS_RESPONSE", value: error })
    }
}

function* visibilityDashboard(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'PATCH', config.credentials.url + '/profile/' + actions.id + '/', requestOptions)

        yield put({ type: "RESPONSE_DASHBOARD_VISIBILITY", value: response })

    } catch (error) {
        yield put({ type: "RESPONSE_DASHBOARD_VISIBILITY", value: error })
    }
}

function* hashExportUsers(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? config.credentials.url + '/user_report/?offset=0&limit=1000000'
                : config.credentials.url +
                '/user_report/' +
                actions.query +
                '&offset=0&limit=100000';
        const response = yield call(apiCall, 'get', url, requestOptions);
        yield put({ type: 'HASH_EXPORT_USERS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_USERS_RESPONSE', value: error });
    }
}

function* checkExportUsers(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_USERS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_USERS_RESPONSE', value: error });
    }
}

function* updateExportUsers(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'PUT',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'UPDATE_EXPORT_USERS_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'UPDATE_EXPORT_USERS_RESPONSE', value: error });
    }
}

export function* getUser() {
    yield takeEvery("GET_USER", user)
}
export function* getUsersList() {
    yield takeEvery("GET_USERS", users)
}

export function* addUser() {
    yield takeEvery("ADD_USER", add)
}

export function* removeUser() {
    yield takeEvery("REMOVE_USER", remove)
}

export function* editUser() {
    yield takeEvery("EDIT_USER", edit)
}

export function* getPermission() {
    yield takeEvery("GET_PERMISSIONS", permissions)
}

export function* addVisibilityDashboard() {
    yield takeEvery("VISIBILITY_DASHBOARD", visibilityDashboard)
}

export function* getHashExportUsersList() {
    yield takeEvery('GET_HASH_EXPORT_USERS', hashExportUsers);
}

export function* checkExportUsersList() {
    yield takeEvery('CHECK_EXPORT_USERS', checkExportUsers);
}

export function* updateExportUsersList() {
    yield takeEvery('UPDATE_EXPORT_USERS', updateExportUsers);
}